const LOGIN_SERVICE_URL = import.meta.env.VITE_LOGIN_SERVICE_URL || 'http://localhost:3001';
const AUTH_ENABLED = import.meta.env.VITE_ENABLE_AUTH === 'true';

export const DEV_USERS = [
  { sub: 'seed-user-sub',      name: 'Dev User',       email: 'user@qms.local',      'cognito:groups': ['PowerUser'] },
  { sub: 'seed-poweruser-sub', name: 'Dev PowerUser',  email: 'poweruser@qms.local', 'cognito:groups': ['PowerUser'] },
  { sub: 'seed-mgr-sub',       name: 'Dev Manager',    email: 'mgr@qms.local',       'cognito:groups': ['Manager'] },
  { sub: 'seed-qa-sub',        name: 'Dev QA',         email: 'qa@qms.local',        'cognito:groups': ['QA'] },
  { sub: 'seed-po-sub',        name: 'Dev Process Owner', email: 'po@qms.local',     'cognito:groups': ['ProcessOwner'] },
];

const DEV_USER_KEY = 'qms_dev_user_sub';

export function setDevUser(sub) {
  localStorage.setItem(DEV_USER_KEY, sub);
}

function getLocalUser() {
  const sub = localStorage.getItem(DEV_USER_KEY);
  return (sub && DEV_USERS.find((u) => u.sub === sub)) || DEV_USERS[0];
}

// -- Real auth implementation (Cognito BFF) ----------------------------------

let accessToken = null;
let idToken = null;
let tokenExpiry = null;

async function refreshTokens() {
  try {
    const res = await fetch(`${LOGIN_SERVICE_URL}/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
    });

    if (!res.ok) return false;

    const data = await res.json();
    accessToken = data.accessToken;
    idToken = data.idToken;
    tokenExpiry = Date.now() + (data.expiresIn || 3600) * 1000;
    return true;
  } catch {
    return false;
  }
}

const realAuth = {
  async initAuth() {
    const success = await refreshTokens();
    if (!success) {
      realAuth.redirectToLogin();
      return false;
    }
    return true;
  },

  async getAccessToken() {
    if (accessToken && tokenExpiry && Date.now() < tokenExpiry - 60000) {
      return accessToken;
    }
    if (await refreshTokens()) {
      return accessToken;
    }
    realAuth.redirectToLogin();
    return null;
  },

  getUserInfo() {
    if (!idToken) return null;
    try {
      return JSON.parse(atob(idToken.split('.')[1]));
    } catch {
      return null;
    }
  },

  isAuthenticated: () => !!accessToken,
  redirectToLogin: () => { window.location.href = LOGIN_SERVICE_URL; },

  async logout() {
    try {
      // Call the login service to clear httpOnly cookies
      await fetch(`${LOGIN_SERVICE_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear local tokens regardless of server response
      accessToken = null;
      idToken = null;
      tokenExpiry = null;
      realAuth.redirectToLogin();
    }
  },
};

// -- No-op auth (local dev) --------------------------------------------------

const noopAuth = {
  initAuth: async () => true,
  getAccessToken: async () => null,
  getUserInfo: () => getLocalUser(),
  isAuthenticated: () => true,
  redirectToLogin: () => {},
  logout: () => {},
};

// -- Export the active implementation ----------------------------------------

const auth = AUTH_ENABLED ? realAuth : noopAuth;

export const initAuth = auth.initAuth;
export const getAccessToken = auth.getAccessToken;
export const getUserInfo = auth.getUserInfo;
export const isAuthenticated = auth.isAuthenticated;
export const redirectToLogin = auth.redirectToLogin;
export const logout = auth.logout;
